import React from 'react';

const Employers = () => {
    return (
        <p>This is the employers info page</p>
    )
}

export default Employers;
